<template>
    <div class="BoardDetailsx" v-if="project">
       <div class="boardx">
        <div class="columns">
          <div class="column">
        <b-breadcrumb
            
        >
            <!-- <b-breadcrumb-item tag="router-link" :to="{ path: '/dashboard' }">Projects</b-breadcrumb-item> -->
            <b-breadcrumb-item :to="'/projects/'+ project.id">{{ project.name }}&nbsp;</b-breadcrumb-item>
            <b-breadcrumb-item :to="'/projects/'+ project.id" active>{{ stepName(stepId) }}</b-breadcrumb-item>
            
        </b-breadcrumb>
      </div>
      <div class="column">
        <train-header :stepId="stepId" :header="true" :project="project" :currentUser="currentUser" :metrics="metrics" :rowsLength="rows.filter(r => Array.isArray(r.labels) ? r.labels.length > 0 : false ).length" @showModels="showModels"/>
      </div>
      </div>
      
          <div class="columns">
             <div class="column is-1">
                <b-menu>
                    <b-menu-list label="PROJECT">
                      <b-menu-item v-for="item in getMenuItems()" :key="item.id"
                       :label="item.name"
                       class="is-info"
                       :active="stepId == item.id || (stepId == undefined && item.id == 'inference')"
                       tag="router-link"
                       :to="'/projects/'+ project.id +'/'+ item.id">
                      </b-menu-item>
                   </b-menu-list>
                    <br>
                    <b-skeleton size="is-large" height="60px" :active="!progress"></b-skeleton>
                    <div v-if="progress">
                        <b-menu-list label="NEXT STEP">
                      <div class="block">
                        <h4 class="subtitle is-6" v-if="!project.datasetId">👉 Upload a dataset</h4>
                        <h4 class="subtitle is-6" v-else-if="project.datasetId && !project.model_metrics && !project.labels">👉 Provide labels</h4>
                        <h4 class="subtitle is-6" v-else-if="project.datasetId && !project.model_metrics && project.labels && (rows && rows.filter( item => item.label != false).length < 5)">👉 Annotate your data</h4>
                        <h4 class="subtitle is-6" v-else-if="!project.model_metrics">👉 Let's annotate your data</h4> 
                        <!-- <h4 class="subtitle is-6" v-else-if="project.model_metrics && project.model_metrics['accuracy'] < 0.9">Performance is below average. <br>
                            <small><a href="" target="blank">Learn how to improve</a>.</small>
                        </h4>  -->
                        
                        <h4 class="subtitle is-6" v-else>
                            👉 Test your AI model
                        </h4>
                        
                        <!-- <h4 class="subtitle is-6" v-else-if="project.modelId && currentUser.predictionsTotal != undefined && currentUser.predictionsTotal <= 20 && project.model_metrics.accuracy != undefined && project.model_metrics.accuracy < 0.78">Improve your model</h4>
                        <h4 class="subtitle is-6" v-else-if="project.modelId && project.model_metrics.accuracy != undefined && project.model_metrics.accuracy >= 0.78">Ready! Lets integrate it</h4> -->
                      </div>
                    </b-menu-list>
                    <br>

                    <b-menu-list label="LABELING" v-if="0">
                        <b-button @click="showLabeling = !showLabeling" type="is-white" size="is-small" class="is-pulled-right">
                        <span class="icon">
                            <i v-if="showLabeling" class="fa fa-chevron-up fa-2xs"></i>
                            <i v-if="!showLabeling" class="fa fa-chevron-down fa-2xs"></i>
                        </span>
                        </b-button>
                      <!-- <ProjectDocumentsLabels :projectId="projectId" :project="project" :projectDocuments="projectDocuments"/> -->
                      <!-- <div class="block" v-if="rows && project.labels && project.model_metrics && project.model_metrics.per_label">
                        
                        <ProjectMetrics :project="project"/>
                        
                      </div> -->
                      <!-- <div class="block" v-if="showLabeling && rows && project.labels && project.type == 'classification'">
                        
                        <span v-if="metrics.length > 0" >
                            <span class="is-size-7 subtitle">
                                Total
                            
                            <b-progress style="margin-bottom:0.8em;" :rounded="true" type="is-info" size="is-smallx" :max="metrics.map( m => m.labeled).reduce((a, b) => a + b, 0)" :value="metrics.map( m => m.labeled).reduce((a, b) => a + b, 0)" show-value>
                                {{ metrics.map( m => m.labeled).reduce((a, b) => a + b, 0) }}
                            </b-progress>
                            </span>
                            <span v-for="label, idx in metrics" class="is-size-7 subtitle" v-if="metrics && label.defined">
                                {{ label.label }} 
                                <b-progress style="margin-bottom:0.5em;" :rounded="true"  format='percent' type="is-info" size="is-smallx" :max="Math.max(...metrics.map( m => m.labeled))*1.2" :value="label.labeled" show-value>
                                    
                                    {{ label.labeled }}
                                    
                                </b-progress>
                            </span>
                        </span>
                      </div> -->
                      </b-menu-list>
                      

                    </div>
                    <!-- <div class="block">
                      <h4 class="title is-6">Usage</h4>
                        <b-progress type="is-success" size="is-small" :max="currentUser.plan.datasetRowsLimit" :value="currentUser.datasetRowsTotal" show-value>
                            <span class="is-pulled-right">Dataset rows {{ currentUser.datasetRowsTotal }} / {{ currentUser.plan.datasetRowsLimit }}</span>
                        </b-progress>
                        <b-progress type="is-success" size="is-small" :max="currentUser.plan.modelTrainingsLimit" :value="currentUser.modelTrainingsTotal" show-value>
                            Trainings {{ currentUser.modelTrainingsTotal }} / {{ currentUser.plan.modelTrainingsLimit }}
                        </b-progress>
                        <b-progress type="is-success" size="is-small" :max="currentUser.plan.predictionsLimit" :value="currentUser.predictionsTotal" show-value>
                            Predictions {{ currentUser.predictionsTotal }} / {{ currentUser.plan.predictionsLimit }}
                        </b-progress>
                    </div> -->
                    
                </b-menu>
                <!-- <ProjectMetrics :project="project"/> -->
             </div>
             <div class="column">
                
                <div class="page-info" >
                     <div class="columns">
                         
                         <div class="column is-full">
                            <ProjectStatus :project="project" />
                            <Insights :project="project" :currentUser="currentUser" v-if="stepId == 'insights' || !stepId"/>  
                            <Uploads :project="project" :projectDatasets="projectDatasets" :currentUser="currentUser" v-if="stepId == 'uploads'"/>
                            <Labels :project="project" :projectDatasets="projectDatasets" :projectDocuments="rows" :currentUser="currentUser" v-if="stepId == 'labels'"/>
                            <Samples :modelId="project.modelId" :project="project" :projectDatasets="projectDatasets" :projectDocuments="rows" :currentUser="currentUser" v-if="stepId == 'samples'"/>
                            <Prompts :project="project" :modelId="project.modelId" :projectDatasets="projectDatasets" :projectDocuments="rows" :currentUser="currentUser" v-if="stepId == 'prompts'"/>
                            <Data :project="project" :rows="rows" :projectModels="projectModels" :projectDatasets="projectDatasets" :currentUser="currentUser" v-if="stepId == 'data'"/>
                            <Train :project="project" :rows="rows" :projectModels="projectModels" :projectDatasets="projectDatasets" :currentUser="currentUser" :currentOrg="currentOrg" :viewModels="viewModels"  :tabId="tabId" v-if="stepId == 'train'"/>
                            <Finetune :project="project" :projectDocuments="rows" :currentUser="currentUser" v-if="stepId == 'finetune'"/>
                            <Connect :project="project" :projectDocuments="rows" :currentUser="currentUser" :projects="projects" :tabId="tabId" v-if="stepId == 'connect'"/>
                            <Deploy :project="project" :currentUser="currentUser" :tabId="tabId"  v-if="stepId == 'monitor'"/>
                            <Settings :project="project" :currentUser="currentUser" :tabId="tabId" v-if="stepId == 'settings'"/>
                         </div>
                     </div>
 
                 </div>
             </div>
          </div>
 
       </div>
       
       <b-modal
            v-model="isModalVideoOpen"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Model"
            aria-modal
            scroll="keep">
            <template #default="props">
              
                <div class="has-text-centered card model-card">
                        <iframe v-if="isModalVideoOpen" width="750" height="422" src="https://www.youtube.com/embed/x47tFVJwVac?si=O9VeyYFfpMiSSJ1V&amp;controls=0&amp;start=2&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
            </template>
        </b-modal>

    </div>

    
 </template>
 
 <script>
 import Uploads from "@/dashboard/Project/Uploads.vue";
 import Labels from "@/dashboard/Project/Labels.vue";
 import Samples from "@/dashboard/Project/Samples.vue";
 import Prompts from "@/dashboard/Project/Prompts.vue";
 import Train from "@/dashboard/Project/Train.vue";
 import Data from "@/dashboard/Project/Data.vue";
 import Finetune from "@/dashboard/Project/Finetune.vue";
 import Connect from "@/dashboard/Project/Connect.vue";
 import Deploy from "@/dashboard/Project/Deploy.vue";
 import Settings from "@/dashboard/Project/Settings.vue";
 import ProjectDocumentsLabels from "@/components/ProjectDocumentsLabels.vue";
 import ProjectMetrics from "@/components/ProjectMetricsChart.vue";
 import Insights from "@/dashboard/Project/Insights.vue";
 import TrainHeader from '@/dashboard/Project/TrainHeader.vue'
 import { mapState } from 'vuex';

    export default {
      props: ["projectId","stepId","tabId"],
      name: "ProjectIndex",
      data: () => {
        return {
         isModalVideoOpen: true,
         progress: false,
         isModalTrainingMetricsOpen: false,
         isModalNewModelOpen: false,
         currentTab: null,
         showLabeling: true,
         show_plots: false,
         dataset: false,
         documentsOk: false,
         barchart_metrics: ['f1score', 'count', 'precision'],
         metric_name: 'f1score',
         items: {
          "v1": [
            // {
            //   name: "Insights", id: "insights"
            // },
            {
              name: "Train", id: "train"
            },
            {
              name: "Connect", id: "connect"
            },
            
            // {
            //   name: "Test", id: "deploy"
            // },
            {
              name: "Monitor", id: "monitor"
            },
            
            // {
            //   name: "Add text", id: "uploads"
            // },
            // {
            //   name: "Add label", id: "labels"
            // },
            {
              name: "Settings", id: "settings"
            }
         ], "other": [
            {
              name: "Fine-tune", id: "finetune"
            },
            {
              name: "Inference", id: "deploy"
            },
            {
              name: "Add text", id: "uploads"
            },
            {
              name: "Settings", id: "settings"
            }
         ]}
        }
      },
      components: {
        Uploads,
        Labels,
        Prompts,
        Train,
        Data,
        Deploy,
        Settings,
        Samples,
        Finetune,
        Connect,
        ProjectMetrics,
        ProjectDocumentsLabels,
        Insights,
        TrainHeader
      },
      computed: { 
        rows() {
                return this.$store.getters.rowsByDataset(this.project.datasetId)
        },
        ...mapState([
            'viewModels',   
            'project',
            'model',
            'currentUser',
            'currentOrg',
            'projectDatasets',
            'projectModels',
            'projects',
            'metrics'
      ])},
      filters: {
       capitalize: function (value) {
         if (!value) return ''
         let name = this.items.filter(x => x.id == value)
         
         name = name.toString().replace("-", " ")
         return name.charAt(0).toUpperCase() + name.slice(1)
       }
     },
      methods:{
        showModels(){
            this.viewModels = !this.viewModels
            return this.viewModels
        },
        getMenuItems(){
            return this.items.v1
        },
        stepName(stepId){
           stepId = (stepId == undefined)?'train':stepId
           return this.getMenuItems().filter(x => x.id == stepId)[0].name
        },
        fetchDocuments(){
          this.progress = true
          
          if (this.rows == undefined) {
            return;
          }
          this.getLabelsStatistics()
          if (this.rows.length > 0){
            this.documentsOk = true
          }
          
        },
        fetchResources(){
          if (this.project){
            this.progress = true
            // this.$store.dispatch("projectModels", this.project.modelId);
            this.$store.dispatch("projectDatasets", this.project.datasetId);
            this.$store.dispatch("currentModel", this.project.modelId);
          }
        },
        createRow(row){
            // must have datasetId, projectId, uploadId, text (or label)
            // {
            //     text: row.data[that.text_column_key],
            //     label: label,
            //     datasetId: that.datasetId,
            //     uploadId: that.uploadId,
            //     projectId: that.projectId
            // }
            this.$store.dispatch('createRow', row)
        },
      },
      // watch: {
      //   projectDocuments() {
      //     if(this.projectDocuments != undefined){
      //       setTimeout(() => { this.fetchDocuments() }, 1000)
      //     }
      //   }
      // },

      mounted() {
        this.$store.dispatch("currentProject", this.projectId).then( (p) => {
            this.$store.dispatch('getRowsByDataset', p.datasetId)
        })
        this.isModalVideoOpen = (this.tabId == 'tutorial') ? true : false
      },
      created() {
        this.$store.dispatch("currentUser").then( () => {
            const organizationId = (this.currentUser.organizationId ? this.currentUser.organizationId : this.currentUser.id)
            this.$store.dispatch("currentOrg", organizationId);
        })

        this.$store.dispatch("currentProject", this.projectId);
        
        setTimeout(() => { this.fetchResources() }, 3000)
        

      },
    };
 </script>
 
 <style lang="scss" scoped>
 .BoardDetails {
   .board {
     .items {
       display: grid;
       grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
       gap: 16px;
 
       .item {
         position: relative;
 
         &:hover {
           .actions {
             display: unset;
           }
         }
 
         a {
           color: inherit;
           text-decoration: none;
         }
 
         .image-container {
           width: 100%;
           padding-top: 56.25%;
           overflow: hidden;
           background: #dedede;
           position: relative;
           border-radius: 4px;
           box-shadow: 1px 1px 1px #adadad;
 
           img {
             width: 100%;
             height: 100%;
             object-fit: cover;
             position: absolute;
             top: 0;
             left: 0;
           }
         }
 
         .info {
           margin-top: 12px;
 
           .title {
             display: block;
             margin-bottom: 4px;
             text-transform: capitalize;
             display: -webkit-box;
             -webkit-line-clamp: 1;
             -webkit-box-orient: vertical;
             overflow: hidden;
           }
           .description {
             margin: 0;
             margin-bottom: 8px;
             display: -webkit-box;
             -webkit-line-clamp: 2;
             -webkit-box-orient: vertical;
             overflow: hidden;
           }
           .hostname {
             display: block;
             color: #a3a3a3;
           }
         }
 
         .actions {
           position: absolute;
           display: none;
           right: 0;
           top: 0;
           margin: 8px;
 
           .action {
             border: solid 1px black;
             padding: none;
             background: white;
             border-radius: 50%;
             width: 24px;
             height: 24px;
             outline: none;
           }
         }
       }
     }
   }
 }

 progress.show-value {
  position: relative;
}

progress.show-value:after {
  content: attr(value)'%';
  position: absolute;
  top: 0;
  left: 0%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  font-size: calc(1rem / 1.5);
  line-height: 1rem;
}

progress.show-value.is-small:after {
  font-size: calc(0.75rem / 1.5);
  line-height: 0.75rem;
}

progress.show-value.is-medium:after {
  font-size: calc(1.25rem / 1.5);
  line-height: 1.25rem;
}

progress.show-value.is-large:after {
  font-size: calc(1.5rem / 1.5);
  line-height: 1.5rem;
}
 
 </style>
 